<template>
    <select class="form-control" id="statelist" placeholder="State" @change="handleChange">
        <option data-country="484" value="Aguascalientes">Aguascalientes</option>
        <option data-country="484" value="Baja California Norte">Baja California Norte</option>
        <option data-country="484" value="Baja California Sur">Baja California Sur</option>
        <option data-country="484" value="Campeche">Campeche</option>
        <option data-country="484" value="Chiapas">Chiapas</option>
        <option data-country="484" value="Chihuahua">Chihuahua</option>
        <option data-country="484" value="Ciudad de Mexico">Ciudad de Mexico</option>
        <option data-country="484" value="Coahuila">Coahuila</option>
        <option data-country="484" value="Colima">Colima</option>
        <option data-country="484" value="Durango">Durango</option>
        <option data-country="484" value="Estado de México">Estado de México</option>
        <option data-country="484" value="Guanajuato">Guanajuato</option>
        <option data-country="484" value="Guerrero">Guerrero</option>
        <option data-country="484" value="Hidalgo">Hidalgo</option>
        <option data-country="484" value="Jalisco">Jalisco</option>
        <option data-country="484" value="Michoacán">Michoacán</option>
        <option data-country="484" value="Morelos">Morelos</option>
        <option data-country="484" value="Nayarit">Nayarit</option>
        <option data-country="484" value="Nuevo León">Nuevo León</option>
        <option data-country="484" value="Oaxaca">Oaxaca</option>
        <option data-country="484" value="Puebla">Puebla</option>
        <option data-country="484" value="Queretaro">Queretaro</option>
        <option data-country="484" value="Quintana Roo">Quintana Roo</option>
        <option data-country="484" value="San Luis Potosi">San Luis Potosi</option>
        <option data-country="484" value="Sinaloa">Sinaloa</option>
        <option data-country="484" value="Sonora">Sonora</option>
        <option data-country="484" value="Tabasco">Tabasco</option>
        <option data-country="484" value="Tamaulipas">Tamaulipas</option>
        <option data-country="484" value="Tlaxcala">Tlaxcala</option>
        <option data-country="484" value="Veracruz">Veracruz</option>
        <option data-country="484" value="Yucatán">Yucatán</option>
        <option data-country="484" value="Zacatecas">Zacatecas</option>
        </select>
</template>

<script>
export default {
methods: {
    handleChange (e) {
      // Set Regus State.
      if(e.target.options.selectedIndex > -1) {
        let regusState = e.target.value;
        this.$store.commit('setRegusState', regusState);
      }
    }
  }
}
</script>

<style>

</style>
